import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { ContainerLoadingStatus, ContainerStatusEnum, BlStatusEnum, JobCompletedEnum, InsuranceType, ModeOfExportEnum } from "@gtpl/shared-models/common-models";
import { ContainerLog } from "./container-log.entity";
import {LoadingSheetEntity} from './dto/loading-sheet-entity'


@Entity('container')
export class Container {

  @PrimaryGeneratedColumn("increment", { name: 'container_id' })
  containerId: number;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "container_number"
  })
  containerNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "bl_no"
  })
  blNo: string;

  @Column("int", {
    nullable: true,
    name: "sale_order_id"
  })
  saleOrderId: number;
  @Column("int", {
    nullable: true,
    name: "insurance_id"
  })
  insuranceId: number;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "line_seal"
  })
  lineSeal: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "e_seal"
  })
  eSeal: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "scac"
  })
  scac: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "couriourNo"
  })
  couriourNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "booking_no"
  })
  bookingNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "bill_of_lading"
  })
  billOfLading: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "shipping_bill_no"
  })
  shippingBillNo: string;


  @Column({
    type: 'enum',
    enum: ContainerStatusEnum,
    nullable: false,
    name: 'status',
    default: ContainerStatusEnum.BOOKED
  })
  containerStatus: ContainerStatusEnum;
  @Column({
    type: 'enum',
    enum: InsuranceType,
    nullable: false,
    name: 'insurance_type',
    // default: InsuranceType.Internal
  })
  insuranceType: InsuranceType;
  @Column({
    type: 'enum',
    enum: JobCompletedEnum,
    nullable: false,
    name: 'doc_dispatch_status',
    // default: JobCompletedEnum.NO
  })
  documentDispatchStatus: JobCompletedEnum;

  @Column({
    type: 'enum',
    enum: ContainerLoadingStatus,
    nullable: false,
    name: 'loading_status',
    default: ContainerLoadingStatus.OPEN
  })
  loadingStatus: ContainerLoadingStatus;

  @Column({
    type: 'enum',
    enum: BlStatusEnum,
    nullable: false,
    name: 'bl_status',
    default: BlStatusEnum.NOT_RECEIVED
  })
  blStatus: BlStatusEnum;

  
  @Column({
    nullable: true,
    name: "expected_delivery_date"
  })
  expectedDeliveryDate: Date;

  @Column({
    nullable: true,
    name: "etd"
  })
  etd: Date;
  
  
  @Column("date", {
    nullable: true,
    name: "doc_dispatch_date"
  })
  documentDispatchDate: string;
  @Column("date", {
    nullable: true,
    name: "insurance_date"
  })
  insuranceDate: string;
  @Column({
    nullable: true,
    name: "obl_etd"
  })
  oblEtd: Date;

  @Column("date", {
    nullable: true,
    name: "ho_issued_date"
  })
  hoIssuedDate: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "reference_number"
  })
  referenceNumber: string; 
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vc_no"
  })
  vcNo: string; 
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "hoCertificateNo"
  })
  hoCertificateNo: string; 
  

  @Column({
    nullable: true,
    name: "loading_date"
  })
  loadingDate: Date;
  @Column({
    nullable: true,
    name: "actual_date"
  })
  actualDate: Date;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vehicle_number"
  })
  vehicleNumber: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "driver_name"
  })
  driverName: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "driver_phone_number"
  })
  driverPhoneNumber: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "cha"
  })
  cha: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "transporter"
  })
  transporter: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "assigned_by"
  })
  assignedBy: string;
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "tracking_no"
  })
  trackingNo: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vessel_name"
  })
  vesselName: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vessel_number"
  })
  vesselNumber: string;
  @Column({
    nullable: true,
    name: "vessel_schedule"
  })
  vesselSchedule: Date;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "port_of_transhipment"
  })
  portOfTranshipment: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "referenceNo"
  })
  referenceNo: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "port_of_discharge"
  })
  portOfDischarge: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "qc_report"
  })
  qcReport: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "buyer_inspection_report"
  })
  buyerInspectionReport: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vessel_schedule_approval"
  })
  vesselScheduleApproval: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "temperature"
  })
  temperature: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "scroll_no"
  })
  scrollNo: string;

  @Column({
    nullable: true,
    name: "scroll_date"
  })
  scrollDate: Date;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "port_code"
  })
  portCode: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "importing_vessel_name"
  })
  importingVesselName: string;
  @Column("boolean", {
    nullable: false,
    name: "draft_received",
    default: false
})
draftReceived: boolean;

@Column("date", {
  nullable: true,
  name: "date_of_transhipment"
})
dateOfTranshipment: string;
@Column("date", {
  nullable: true,
  name: "shipped_onboard_date"
})
shippedOnboardDate: string;

@Column("date", {
  nullable: true,
  name: "discharge_date"
})
dischargeDate: string;
@Column("date", {
  nullable: true,
  name: "destination_date"
})
destinationDate: string;
  
  @Column("int", {
    nullable: true,
    name: "unit_id"
  })
  unitId: number;
  @Column("int", {
    nullable: true,
    name: "insurance_amount"
  })
  insuranceAmount: number;

   @Column( {
    nullable: true,
    name: "shipping_bill_date"
  })
  shippingBillDate:string;

  @Column({
    nullable: true,
    name: "examination_date"
  })
  examinationDate:Date;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "stuffing_start_time"
  })
  stuffingStartTime:string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "stuffing_completion_time"
  })
  stuffingCompletionTime: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "time_taken_for_stuffing"
  })
  timeTakenForStuffing: string;
  @Column("int", {
    nullable: true,
    name: "authorised_by"
  })
  authorisedBy: number;

  @Column("int", {
    nullable: true,
    name: "loadingSheet_number"
  })
  loadingSheetNum: number;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "container_size"
  })
  containerSize: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "branch_code"
  })
  branchCode: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "temp_indicator_no1"
  })
  tempIndicatorNo1: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "freight_after_shipment"
  })
  freightAfterShipment: string;


  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "temp_indicator_no2"
  })
  tempIndicatorNo2: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "temp_indicator_no3"
  })
  tempIndicatorNo3: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "shipping_liner"
  })
  shippingLiner: string;
  @Column({
    nullable: true,
    name: "eta"
  })
  eta: Date;

@Column( {
  nullable: true,
  name: "leo_date"
})
leoDate:string;

@Column( {
  nullable: true,
  name: "brc_rel_date"
})
brcRelDate:string;


@Column({
  nullable:true,
  name :"temperature_degree"
})
temperaturee:string;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column({
    default: 0,
    name: "check_list_status"
  })
  checkListStatus: number;

  
  @Column({
    default: 0,
    name: "shippment_details_status"
  })
  shippmentDetailsStatus: number;

  @Column('boolean',{
    name:'ship_containers_mis_flag',
    default:0
  })
  shipConatinersMisFlag : boolean

  @Column('enum',{
    name:'mode_of_export',
    enum:ModeOfExportEnum
  })
  modeOfExport : ModeOfExportEnum

  @Column('boolean',{
    name:'post_shipment_received_status',
    default:0
  })
  postShipmentReceivedStatus : boolean

  @OneToMany(type => ContainerLog, containerLog => containerLog.containerInfo)
  containerLogInfo: ContainerLog[];

  @OneToMany(type => LoadingSheetEntity,loadingSheet =>loadingSheet.loadingSheetNum,{cascade:true})
  loadingSheet:LoadingSheetEntity[];
}
